import { useEffect, useState } from 'react';

import { ACTING_USER_MISMATCH_EVENT, isActingUserStale } from '@shared/utils/acting-user';

export const useActingUserGuard = () => {
  const [actingUserChanged, setActingUserChanged] = useState(false);

  useEffect(() => {
    const handleMismatchEvent = () => setActingUserChanged(true);

    const checkCookie = () => {
      if (isActingUserStale()) {
        setActingUserChanged(true);
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        checkCookie();
      }
    };

    checkCookie();
    window.addEventListener('focus', checkCookie);
    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener(ACTING_USER_MISMATCH_EVENT, handleMismatchEvent);

    return () => {
      window.removeEventListener('focus', checkCookie);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener(ACTING_USER_MISMATCH_EVENT, handleMismatchEvent);
    };
  }, []);

  return actingUserChanged;
};
